import { useTranslation } from '@parsina/framework/clinical/src/i18n/index';
import OnboardingShell from '../Onboarding/Shell.jsx';
import PrizeStage from '../Onboarding/PrizeStage.jsx';

// ── The wheel, reached without the wizard ─────────────────────────────────────
//
// docs/ONBOARDING_PRIZE_WHEEL_PLAN.md §5.3. `is_onboarded` flips the moment the
// council number is saved, so a doctor who closes the app between that step and
// the wheel never sees the wizard again — and a doctor who was ALREADY on the
// platform when the campaign started never saw it at all. Both are handed the
// same offer on the boot query (`checkOnboardingStatus.pendingPrizeDraw`), and
// both land here.
//
// NOT A ROUTE, on purpose: it renders in App.jsx before `<BrowserRouter>`, in
// the same place and for the same reason as `<OnboardingScreen>` — there is no
// shell yet, and a URL for it would be a URL a doctor could bookmark, share, or
// return to after the prize was already paid.
//
// It is the SAME `PrizeStage` the wizard renders. The only difference is what
// «ادامه» means: there, the next stage; here, the panel.
export default function PrizeWheelScreen({ draw, onDone }) {
  const { t } = useTranslation();

  if (!draw) return null;

  return (
    <OnboardingShell subtitle={draw.title || t('auth.onboarding.prize.title')}>
      <PrizeStage draw={draw} onDone={onDone} />
    </OnboardingShell>
  );
}
